import { Button } from "antd";
import "./deliveryButton.css";
import { UserAddOutlined } from "@ant-design/icons";

const PlusButtonDoc = () => {
  const title = "";
  function setAddDoctorVisible(arg0: boolean): void {
    throw new Error("Function not implemented.");
  }

  return (
    <>
      <button
        className="buttonc centered"
        onClick={() => setAddDoctorVisible(true)}
      >
        <span className="buttonc__text">Aggiungi Dottore</span>
        <span className="buttonc__icon">
          <UserAddOutlined rev={undefined} />
        </span>
      </button>
    </>
  );
};

export default PlusButtonDoc;
